/**
 * FilterChips — WhatsApp-style horizontal pill filter (V1.9.32).
 * All / Unread / Groups / Starred (or custom set). Client-side only.
 */
import React from "react";

export default function FilterChips({ value, onChange, chips, testIdPrefix = "inbox-filter" }) {
    return (
        <div
            role="tablist"
            data-testid={`${testIdPrefix}-row`}
            className="flex items-center gap-2 px-3 py-2 overflow-x-auto no-scrollbar bg-white sticky top-0 z-10 border-b border-ink/5"
        >
            {chips.map((c) => {
                const active = value === c.value;
                return (
                    <button
                        key={c.value}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => onChange(c.value)}
                        data-testid={`${testIdPrefix}-${c.value}`}
                        className={`whitespace-nowrap inline-flex items-center gap-1 px-3 h-8 rounded-full text-[13px] font-medium transition
                            ${active
                                ? "bg-emerald-100 text-emerald-800 ring-1 ring-emerald-300"
                                : "bg-black/5 text-ink/70 hover:bg-black/10"}`}
                    >
                        {c.label}
                        {typeof c.count === "number" && c.count > 0 && (
                            <span className={`text-[11px] ${active ? "text-emerald-700" : "text-ink/50"}`}>{c.count}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
